import { API_BASE_URL } from './api';

export const getSalesRevenueReport = async (
  filterType: 'daily' | 'weekly' | 'monthly',
  washType: string,
  page: number = 1,
  limit: number = 10
) => {
  const params = new URLSearchParams({
  type: filterType,
  washType,
  page: page.toString(),
  limit: limit.toString(),
});


  const response = await fetch(`${API_BASE_URL}/reports/sales-revenue?${params}`);
  return await response.json();
};

interface ServicePerformanceReportParams {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
}

export const getServicePerformanceReport = async ({
  page,
  limit,
  fromDate,
  toDate
}: {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
} = {}) => {
  const params = new URLSearchParams();
  if (page !== undefined) params.append("page", page.toString());
  if (limit !== undefined) params.append("limit", limit.toString());
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);

  const response = await fetch(`${API_BASE_URL}/reports/service-performance?${params.toString()}`);
  if (!response.ok) throw new Error("Network response was not ok");
  return await response.json();
};

/* -------------------- 3️⃣ CUSTOMER FEEDBACK & RATINGS SUMMARY -------------------- */
export const getCustomerFeedbackReport = async ({
  page = 1,
  limit = 10,
  fromDate,
  toDate,
  customer_name
}: {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  customer_name?: string;
} = {}) => {
  const params = new URLSearchParams();
  params.append("page", page.toString());
  params.append("limit", limit.toString());
  if (fromDate) params.append("from_date", fromDate);
  if (toDate) params.append("to_date", toDate);
  if (customer_name) params.append("customer_name", customer_name);

  const response = await fetch(`${API_BASE_URL}/reports/customer-feedback?${params}`);
  if (!response.ok) throw new Error("Failed to fetch Customer Feedback Report");
  return await response.json();
};

export const getCustomerReports = async ({
  type,
  days,
  page,
  limit,
}: {
  type?: "frequent" | "inactive";
  days?: number;
  page?: number;
  limit?: number;
} = {}) => {
  const params = new URLSearchParams();
  if (type) params.append("type", type);
  if (days) params.append("days", days.toString());
  if (page) params.append("page", page.toString());
  if (limit) params.append("limit", limit.toString());

  const response = await fetch(`${API_BASE_URL}/reports/customer-reports?${params.toString()}`);
  if (!response.ok) throw new Error("Network response was not ok");
  return await response.json();
};

